import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA9acWfGf7tfuYoh2Ti1d_mlcp8omqkJUs",
  authDomain: "simple-dictionary-app.firebaseapp.com",
  projectId: "simple-dictionary-app",
  storageBucket: "simple-dictionary-app.firebasestorage.app",
  messagingSenderId: "333477781206",
  appId: "1:333477781206:web:bcb94806e56ce7cb6d3377",
  measurementId: "G-89GZ0P3G5M"
};

console.log("Firebase config:", { ...firebaseConfig, apiKey: "HIDDEN" });

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
